module.exports = __webpack_public_path__ + "img/8.33929b56.png";